import apps from './apps.json';

export default apps;
  
